














import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({
  name: 'Strat',
})
export default class Strat extends Vue {
  @Prop({ required: true }) readonly strat!: string;
  @Prop({ required: true }) readonly status!: string;
}
